import { Pipe, PipeTransform } from '@angular/core';
import { UtilityService } from 'app/shared/services/utility/utility.service';

@Pipe({
    name: 'autoLabel',
    standalone: true,

    // WARN: Use with caution!
    // Use this if the pipe should be called on value changed.
    // pure: false,
})
export class AutoLabelPipe implements PipeTransform {
    public constructor(private readonly utilityService: UtilityService) {}

    public transform(key: string, overrideLabels?: Record<string, string>): string {
        return this.utilityService.autoLabelFromKey(key, overrideLabels);
    }
}
